export const MOCK_TASK_A_ID = 'MOCK_TASK_A_ID'
export const MOCK_TASK_B_ID = 'MOCK_TASK_B_ID'
export const MOCK_TASK_C_ID = 'MOCK_TASK_C_ID'
export const MOCK_TASK_D_ID = 'MOCK_TASK_D_ID'
export const MOCK_TASK_E_ID = 'MOCK_TASK_E_ID'
